// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import './NavBar.css';

// import logo from './assets/images/Mobile-Logo-386-51-FFFF.png';

// const NavBar = () => {
//   const location = useLocation();

//   return (
//     <header className="header">
//       <img src={logo} alt="Bay Capital Advisors Logo" className="logo" />
//       <nav className="nav">
//         <Link to="/" className={location.pathname === "/" ? "active" : ""}>ABOUT US</Link>
//         <Link to="/Services" className={location.pathname === "/Services" ? "active" : ""}>SERVICES</Link>
//         <Link to="/Sectors" className={location.pathname === "/Sectors" ? "active" : ""}>SECTORS</Link>
//         <Link to="/ChinaFocus" className={location.pathname === "/ChinaFocus" ? "active" : ""}>CHINA FOCUS</Link>
//         <Link to="/IndiaFocus" className={location.pathname === "/IndiaFocus" ? "active" : ""}>INDIA FOCUS</Link>
//         <Link to="/Technology" className={location.pathname === "/Technology" ? "active" : ""}>TECHNOLOGY</Link>
//       </nav>
//     </header>
//   );
// };

// export default NavBar;

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';
import logo from './assets/images/Mobile-Logo-386-51-FFFF.png';

function NavBar({ isMobile, closeMenu }) {
  const location = useLocation();
  const navItems = [
    { path: "/", name: "ABOUT US" },
    { path: "/Services", name: "SERVICES" },
    { path: "/Sectors", name: "SECTORS" },
    { path: "/ChinaFocus", name: "CHINA FOCUS" },
    { path: "/IndiaFocus", name: "INDIA FOCUS" },
    { path: "/Technology", name: "TECHNOLOGY" }
  ];

  if (isMobile) {
    return (
      <nav className="mobile-nav">
        {navItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path} 
            onClick={closeMenu}
            className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    );
  }

  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/"> {/* Add this Link wrapper */}
          <img src={logo} alt="Bay Capital Advisors Logo" className="logo" />
        </Link>
      </div>
      <nav className="nav">
        {navItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path} 
            className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    </header>
  );
}

export default NavBar;